<div class="dialog_wrap ride_status_modal pause">
  <div class="content">
    <h2>{{ 'attention' | translate }}</h2>
    <p>
      {{ 'adminSos' | translate }}
    </p>
  </div>

  <div class="btn_full pause_request site_btn">
    <p-button
      (click)="btn_accept()"
      class="btn primary"
      type="submit"
      label="{{ 'request' | translate }}" />
    <p-button
      (click)="btn_close()"
      class="btn primary reject reject_cancel"
      type="submit"
      label="{{ 'cancel' | translate }}" />
  </div>
</div>
